import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Col, DatePicker, Form, message, Row, Select, Space, Input, Checkbox, } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import AutoOpenSelect from '../../SelectComponent/AutoOpenSelect';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import inquiryQuotationTermsCondition from '../../../Common/inquiryQuotationTermsCondition';
import { ReactComponent as Back } from '../../../Images/Back.svg';
import { fetchAlloyDropdown, resetAlloyList, resetCurrentAlloyListPage } from '../../../slices/alloy';
import { fetchTemperDropdown, resetCurrentTemperPage, resetTempersList } from '../../../slices/tempers';
import { reserLatestNalcoRateData, fetchNalcoRateForQuotation } from '../../../slices/nalco-rate';
import { fetchjobWorkList, resetJobWorkList } from '../../../slices/job-work';
import { fetchInquiryById } from '../../../slices/inquiry';
import { convertInquiryToQuotation } from '../../../slices/inquiry-quotation';
import { debounce } from 'lodash';
const { Option } = Select;

export default function ConvertToQuotation() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [form] = Form.useForm();
  const [editorValue, setEditorValue] = useState(inquiryQuotationTermsCondition);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const { loading } = useSelector(state => state.inquiryQuotation);
  const { list: alloyList, loading: alloyLoading, currentPage: alloyCurrentPage, hasMore: alloyHasMore } = useSelector(state => state.alloy);
  const { jobWorkdata, loading: jobWorkLoading } = useSelector(state => state.jobWork);
  const { list: temperList, loading: temperLoading, hasMore: temperHasMore } = useSelector(state => state.temper);
  const { nalcoRateData, loading: nalcoRateLoading} = useSelector(state => state.nalcoRate);


  // Initial data fetching
  useEffect(() => {
    const loadInitialData = async () => {
      dispatch(reserLatestNalcoRateData());
      dispatch(resetJobWorkList());
      dispatch(resetTempersList());
      dispatch(resetAlloyList());
      
      try {
        await Promise.all([
          dispatch(fetchNalcoRateForQuotation()).unwrap(),
          dispatch(fetchAlloyDropdown({ page: 1, pagesize: 1000 })).unwrap(),
          dispatch(fetchTemperDropdown({ page: 1, pagesize: 1000 })).unwrap(),
          dispatch(fetchjobWorkList()).unwrap(),
        ]);
        setIsDataLoaded(true);
      } catch (error) {
        console.error('Error loading initial data:', error);
        message.error('Failed to load required data');
      }
    };

    loadInitialData();
  }, [dispatch]);

  // Fetch inquiry data only after initial data is loaded
  useEffect(() => {
    if (!isDataLoaded) {
      return;
    }

    const fetchInquiry = async () => {
      try {
        const response = await dispatch(fetchInquiryById(id)).unwrap();
        
        if (response) {
          const inquiryData = response?.data;
          if (inquiryData) {
            const quotationDetails = inquiryData.inquiry_details.map((detail) => ({
              id: detail.id || null,
              section_no: detail.section_no,
              alloy: detail.alloy,
              temper: detail.temper,
              length: detail.length || '',
              price_per_kg: nalcoRateData?.rate || 0,
              quantity: '',
              conversion: '',
              packing_cost: '',
              surface_finish: detail?.surface_finish,
              cutting: detail?.cutting,
              cutting_price: detail?.cutting_price,
              machining: detail?.machining,
              machining_price: detail?.machining_price,
              deburring: detail?.deburring,
              deburring_price: detail?.deburring_price,
              anodising: detail?.anodising,
              anodising_description: detail?.anodising_description,
              anodising_price: detail?.anodising_price,
              powder_coating: detail?.powder_coating,
              powder_coating_description: detail?.powder_coating_description,
              powder_coating_price: detail?.powder_coating_price,
              pvdf: detail?.pvdf,
              pvdf_description: detail?.pvdf_description,
              pvdf_price: detail?.pvdf_price
            }));

            const formValues = {
              customer_name: inquiryData.customer_name,
              quotation_details: quotationDetails,
              quotation_date: dayjs(),
              terms_and_condition: inquiryQuotationTermsCondition
            };

            form.setFieldsValue(formValues);
          }
        }
      } catch (error) {
        console.error('Error fetching inquiry:', error);
        message.error('Failed to load inquiry data');
      }
    };

    fetchInquiry();
  }, [id, form, dispatch, isDataLoaded, nalcoRateData]);

 

  

  const handleChange = value => {
    setEditorValue(value);
  };

  const handleFinish = values => {
    values.quotation_date = dayjs(values.quotation_date).format('YYYY-MM-DD');

    dispatch(convertInquiryToQuotation({ id, values }))
      .unwrap()
      .then(result => {
        if (result.success) {
          message.success('Quotation Created Successfully!');
          navigate('/inquiry-quotation-list');
        }
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  return (
    <>
      <div
        style={{
          position: 'sticky',
          zIndex: '1000',
          background: '#fff',
          padding: '16px',
          top: 0,
        }}
      >
        <div className="pagenamerow">
          <h2>Create Inquiry Quotation</h2>
          <div className="bredcrumbwrp">
            <Link to="/inquiry-quotation-list" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/inquiry-quotation-list">Quotations</Link> },
                { title: 'Create Inquiry Quotation' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          form={form}
          onFinish={handleFinish}
        >
          <div className="formrowsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="customer_name"
                  label="Customer Name"
                  rules={[
                    { required: true, message: 'Please select company name' },
                  ]}
                >
                  <Input placeholder="Enter Customer Name" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="quotation_date"
                  label="Quotation Date"
                  rules={[
                    { required: true, message: 'Please select quotation date' },
                  ]}
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    disabled
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="formrowsection">
            <h3 className="rowsubtitle">Add New Item</h3>
            <Form.List name="quotation_details">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Row
                      className="rowItem mx-0"
                      gutter={[24, 24]}
                      align="middle"
                      key={key}
                      style={{ width: '100%' }}
                    >
                      <Col flex="auto">
                        <Row gutter={16}>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'section_no']}
                              label="Section Number"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select a profile number',
                                },
                              ]}
                              style={{ marginBottom: 0 }}
                            >
                              <Input placeholder="Section No" readOnly />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'alloy']}
                              label="Alloy"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select alloy',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Alloy"
                                loading={alloyLoading}
                                notFoundContent={
                                  alloyLoading ? 'Loading...' : 'No options'
                                }
                                value={
                                  form.getFieldValue([
                                    'quotation_details',
                                    name,
                                    'alloy',
                                  ])
                                    ? {
                                      value: form.getFieldValue([
                                        'quotation_details',
                                        name,
                                        'alloy',
                                      ]),
                                      label: '',
                                    }
                                    : undefined
                                }
                                onChange={value =>
                                  form.setFieldValue(
                                    ['quotation_details', name, 'alloy'],
                                    value,
                                  )
                                }
                                disabled
                                allowClear
                                showSearch={true}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {alloyList.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.name} - {el.color_code}
                                  </Option>
                                ))}
                                {alloyLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'temper']}
                              label="Temper"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select temper',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Temper"
                                loading={temperLoading}
                                value={
                                  form.getFieldValue([
                                    'quotation_details',
                                    name,
                                    'temper',
                                  ])
                                    ? {
                                      value: form.getFieldValue([
                                        'quotation_details',
                                        name,
                                        'temper',
                                      ]),
                                      label: '',
                                    }
                                    : undefined
                                }
                                onChange={value =>
                                  form.setFieldValue(
                                    ['quotation_details', name, 'temper'],
                                    value,
                                  )
                                }
                                disabled
                                allowClear
                                showSearch={true}
                                notFoundContent={
                                  temperLoading ? 'Loading...' : 'No options'
                                }
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {temperList.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.name} - {el.code}
                                  </Option>
                                ))}
                                {temperLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'length']}
                              label="Length (mm)"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter length',
                                },
                              ]}
                            >
                              <Input
                                placeholder="0" readOnly
                              />
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'price_per_kg']}
                              label="Price per kg"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Price per kg',
                                },
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'quantity']}
                              label="Quantity (Kg)"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Quantity kg',
                                },
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'conversion']}
                              label="Conversion"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Conversion',
                                },
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>

                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'packing_cost']}
                              label="Packing Cost"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Conversion',
                                },
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>

                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'surface_finish']}
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select surface finish',
                                },
                              ]}
                              label="Surface Finish"
                            >
                              <AutoOpenSelect
                                placeholder="Select jobwork"
                                mode="multiple"
                                disabled
                                allowClear
                                showSearch
                                optionFilterProp="children"
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {jobWorkdata?.map(item => (
                                  <Option key={item.id} value={item.id}>
                                    {item.name}
                                  </Option>
                                ))}
                              </AutoOpenSelect>

                            </Form.Item>
                          </Col>

                          <Form.Item
                            shouldUpdate={(prevValues, currentValues) =>
                              prevValues.quotation_details?.[index]?.surface_finish !==
                              currentValues.quotation_details?.[index]?.surface_finish
                            }
                            noStyle
                          >
                            {({ getFieldValue }) => {
                              const selectedSurfaceFinish = getFieldValue(["quotation_details", index, "surface_finish"]) || [];

                              const selectedItems = jobWorkdata?.filter(item => selectedSurfaceFinish.includes(item.id));


                              // Example: show conditional field if Laser Marking selected
                              const hasEngineering = selectedItems.some(item => item.name === "Engineering");
                              const hasSurfaceTreatment = selectedItems.some(item => item.name === "Surface treatment");

                              return (
                                <>
                                  {/* --- Engineering Fields --- */}
                                  {hasEngineering && (
                                    <>
                                      <Form.Item
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                          prev.quotation_details?.[index]?.cutting !== curr.quotation_details?.[index]?.cutting ||
                                          prev.quotation_details?.[index]?.machining !== curr.quotation_details?.[index]?.machining ||
                                          prev.quotation_details?.[index]?.deburring !== curr.quotation_details?.[index]?.deburring
                                        }
                                      >
                                        {({ getFieldValue }) => {
                                          const cutting = getFieldValue(['quotation_details', index, 'cutting']);
                                          const machining = getFieldValue(['quotation_details', index, 'machining']);
                                          const deburring = getFieldValue(['quotation_details', index, 'deburring']);

                                          return (
                                            <>
                                              {cutting && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Cutting Price"
                                                    name={[name, 'cutting_price']}
                                                    rules={[{ required: true, message: 'Enter Cutting Price' }]}
                                                  >
                                                    <Input placeholder="0.0" />
                                                  </Form.Item>
                                                </Col>
                                              )}

                                              {machining && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Machining Price"
                                                    name={[name, 'machining_price']}
                                                    rules={[{ required: true, message: 'Enter Machining Price' }]}
                                                  >
                                                    <Input placeholder="0.0" />
                                                  </Form.Item>
                                                </Col>
                                              )}

                                              {deburring && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Deburring Price"
                                                    name={[name, 'deburring_price']}
                                                    rules={[{ required: true, message: 'Enter Deburring Price' }]}
                                                  >
                                                    <Input placeholder="0.0" />
                                                  </Form.Item>
                                                </Col>
                                              )}
                                            </>
                                          );
                                        }}
                                      </Form.Item>
                                    </>
                                  )}
                                  {/* --- Surface Treatment Fields --- */}
                                  {hasSurfaceTreatment && (
                                    <>


                                      {/* Nested conditional price fields */}
                                      <Form.Item
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                          prev.quotation_details?.[index]?.anodising !== curr.quotation_details?.[index]?.anodising ||
                                          prev.quotation_details?.[index]?.powder_coating !== curr.quotation_details?.[index]?.powder_coating ||
                                          prev.quotation_details?.[index]?.pvdf !== curr.quotation_details?.[index]?.pvdf
                                        }
                                      >
                                        {({ getFieldValue }) => {
                                          const anodising = getFieldValue(["quotation_details", index, "anodising"]);
                                          const powder_coating = getFieldValue(["quotation_details", index, "powder_coating"]);
                                          const pvdf = getFieldValue(["quotation_details", index, "pvdf"]);
                                          return (
                                            <>
                                              {anodising && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Anodising Price"
                                                    name={[name, "anodising_price"]}
                                                    rules={[{ required: true, message: "Enter Anodising Price" }]}
                                                  >
                                                    <Input placeholder="Enter Anodising Price" />
                                                  </Form.Item>
                                                </Col>
                                              )}

                                              {powder_coating && (
                                                <Col xs={12} md={8} xl={3}>

                                                  <Form.Item
                                                    label="Powder Coating Price"
                                                    name={[name, "powder_coating_price"]}
                                                    rules={[{ required: true, message: "Enter Powder Coating Price" }]}
                                                  >
                                                    <Input placeholder="Enter Powder Coating Price" />
                                                  </Form.Item>

                                                </Col>
                                              )}

                                              {pvdf && (
                                                <Col xs={12} md={8} xl={3}>

                                                  <Form.Item
                                                    label="PVDF Description"
                                                    name={[name, "pvdf_price"]}
                                                    rules={[{ required: true, message: "Enter PVDF Price" }]}
                                                  >
                                                    <Input placeholder="Enter PVDF Price" />
                                                  </Form.Item>

                                                </Col>
                                              )}
                                            </>
                                          );
                                        }}
                                      </Form.Item>
                                    </>
                                  )}
                                </>
                              );
                            }}
                          </Form.Item>
                        </Row>
                      </Col>
                    </Row>
                  ))}
                  {/* <Form.Item>
                    <div className="w-100 flex justify-end">
                      <Button
                        type="primary"
                        onClick={() => {
                          if (fields.length < 500) {

                            add({ price_per_kg: 0 });
                          } else {
                            message.error('You can only add up to 15 records.');
                          }
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Item
                      </Button>
                    </div>
                  </Form.Item> */}
                </>
              )}
            </Form.List>
          </div>
          <Row gutter={16}>
            <Col xs={24}>
              <Form.Item
                name="terms_and_condition"
                label="Terms & Condition"
                rules={[
                  { required: true, message: 'Terms & Condition is required' },
                ]}
                valuePropName="content"
              >
                <ReactQuill
                  value={editorValue}
                  onChange={handleChange}
                  theme="snow"
                  modules={{
                    toolbar: [
                      [{ header: '1' }, { header: '2' }, { font: [] }],
                      [{ list: 'ordered' }, { list: 'bullet' }],
                      ['bold', 'italic', 'underline'],
                      [{ align: [] }],
                      ['link', 'image'],
                      ['blockquote', 'code-block'],
                    ],
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item name="remarks" label="Remarks">
                <Input.TextArea
                  placeholder="Enter Remarks"
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ remarks: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              icon={<PlusOutlined />}
              loading={loading}
            >
              Create Inquiry Quotation
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}
